import EditNoteBookComponent from "./components/EditNoteBookComponent";
import axios from "axios";

const fetchNoteBook = async (noteBookId) => {
    const { data } = await axios.get(`/api/noteBooks/get-one/${noteBookId}`);
    return data;
}

const updateNoteBookApiRequest = async (noteBookId, formInputs) => {
    const { data } = await axios.put(`/api/noteBooks/admin/${noteBookId}`, { ...formInputs, });
    return data;
}

const AdminEditNoteBook = () => {

    return <EditNoteBookComponent updateNoteBookApiRequest={updateNoteBookApiRequest} fetchNoteBook={fetchNoteBook} />;
};

export default AdminEditNoteBook;